module.exports = function clone(obj) {
  return JSON.parse(JSON.stringify(obj));
};



//////////////////
// WEBPACK FOOTER
// ./~/algoliasearch/src/clone.js
// module id = 89
// module chunks = 142807904292071